import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useRoot } from "../../context/RootProvider";
import {
  ADMIN_ROUTE,
  BOOKING_ROUTE,
  DASHBOARD_ROUTE,
  DEV_ROUTE_DETAILS_ROUTE,
  MARKETPLACE_RESOURCE,
  Notification_ROUTE,
  PROPERTIES_ROUTE,
  PROPERTY_RESOURCE,
  RATING_RESOURCE,
  REPORTS_ROUTE,
  TRADE_RESOURCE,
  USERS_ROUTE,
} from "../../routes/routePaths";
import {
  BellIcon,
  Calender,
  DashboardIcon,
  Filter,
  Gallery,
  Property,
  User,
  Rating,
  Marketplace,
  Trade,
} from "./icons";
import { SideBarMenuItem } from "./MenuItems";
type Props = {};

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  flex-grow: 1;
  gap: 13px;
  padding-top: 35px;
  padding-bottom: 35px;
  @media (max-width: 1024px) {
    gap: 30px;
  }
`;

const MenuWrapper = styled.div`
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 260px;
  background-color: #ffffff;
  z-index: 1000;

  @media (max-width: 1024px) {
    width: 45px; /* Sidebar width reduced */
  }
`;

const Spacer = styled.div`
  margin-left: 220px;
  flex-grow: 1;
  min-height: 100vh;

  @media (max-width: 1024px) {
    margin-left: 10px;
  }
`;

type NormalType = {
  type: "normal";
  path: string;
};

type DropType = {
  type: "dropType";
  dropItems: {
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    label: string;
    path: string;
  }[];
};

type CombinedType = NormalType | DropType;

export type ContentType = CombinedType & {
  label: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

const commonContent: ContentType[] = [
  {
    icon: DashboardIcon,
    label: "Dashboard",
    path: DASHBOARD_ROUTE,
    type: "normal",
  },
];
//Property resource ,rating resource,
//marketplace resource
//Trade Resource

const adminContent: ContentType[] = [
  { icon: User, label: "User Management", path: USERS_ROUTE, type: "normal" },
  { icon: User, label: "Admin Management", path: ADMIN_ROUTE, type: "normal" },
  {
    icon: Property,
    label: "Property Management",
    path: PROPERTIES_ROUTE,
    type: "normal",
  },
  {
    icon: Calender,
    label: "Booking Management",
    path: BOOKING_ROUTE,
    type: "normal",
  },
  {
    icon: BellIcon,
    label: "Notification and Logs",
    path: Notification_ROUTE,
    type: "normal",
  },

  {
    icon: Gallery,
    label: "Resource Management",
    type: "dropType",
    dropItems: [
      {
        icon: Property,
        label: "Property",
        path: PROPERTY_RESOURCE,
      },
      {
        icon: Marketplace,
        label: "Marketplace",
        path: MARKETPLACE_RESOURCE,
      },
      {
        icon: Trade,
        label: "Trade",
        path: TRADE_RESOURCE,
      },
      {
        icon: Rating,
        label: "Rating",
        path: RATING_RESOURCE,
      },
    ],
  },
  {
    icon: Filter,
    label: "Reports Management",
    path: REPORTS_ROUTE,
    type: "normal",
  },
  {
    icon: Filter,
    label: "Global Settings",
    path: DEV_ROUTE_DETAILS_ROUTE,
    type: "normal",
  },
];

const operatorContent: ContentType[] = [
  {
    icon: Property,
    label: "Property Management",
    path: PROPERTIES_ROUTE,
    type: "normal",
  },
  {
    icon: Calender,
    label: "Booking Management",
    path: BOOKING_ROUTE,
    type: "normal",
  },
];

const customerSupportContent: ContentType[] = [
  {
    icon: Filter,
    label: "Reports Management",
    path: REPORTS_ROUTE,
    type: "normal",
  },
];

const Sidebar: React.FC<Props> = (_props) => {
  const { auth } = useRoot();

  const getMenuContent = () => {
    switch (auth?.role) {
      case "ADMIN":
        return commonContent.concat(adminContent);
      case "CUSTOMER_SUPPORT":
        return commonContent.concat(customerSupportContent);
      case "OPERATOR":
        return commonContent.concat(operatorContent);
      default:
        return [];
    }
  };

  const menuContent = getMenuContent();

  const location = useLocation();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <MenuWrapper>
        <MenuContainer>
          {menuContent.map((menu) => (
            <SideBarMenuItem
              key={menu.label}
              currentPathname={location.pathname}
              windowWidth={windowWidth}
              {...menu}
            />
          ))}
        </MenuContainer>
      </MenuWrapper>
      <Spacer />
    </div>
  );
};

export default Sidebar;
